import React from "react";

interface CustomButtonProps {
  btnName?: any;
  onClick?: () => void;
  customClasses?: string;
  disabledProp?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  btnName = "Custom Button",
  onClick,
  customClasses = "",
  disabledProp,
}) => {
  return (
    <button
      disabled={disabledProp}
      onClick={onClick}
      className={`block bg-themeBlue text-white py-2 px-5 rounded-md ${customClasses} ${
        disabledProp ? "bg-gray-400" : ""
      }`}
      style={{
        background:disabledProp?"#9ca3af":"#00519d"
      }}
    >
      {btnName}
    </button>
  );
};

export default CustomButton;
